<template>
  <footer>
    <div id="footer-container" class="container">
      <div class="c-footer__wrapper">
        <img class="img-fluid c-client-logo" src="static/tempAssets/fir-logo-copy.svg" />

        <div class="c-footer__menu">
          <div>
            <ul class="nav">
              <router-link class="nav-link" to="/info/tos" target="_blank">Termini di servizio</router-link>
              <router-link class="nav-link" to="/info/cookies_policy" target="_blank">Informativa cookie</router-link>
              <router-link class="nav-link" to="/info/privacy" target="_blank">Privacy</router-link>
              <a class="nav-link" href="mailto:fanizesupport@iquii.com" target="_blank">Supporto</a>
            </ul>
          </div>
        </div>
        <div class="c-footer__partners">
          <a href="https://fanize.it/">
            <span>Powered by</span>
            <img class="img-fluid" src="static/tempAssets/fanize-logo-white.svg" />
          </a>
          <a href="https://iquii.com/">
            <span>Digital partner</span>
            <img class="img-fluid" src="static/tempAssets/iquii-logo-white.svg" />
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="row py-5 footer-bg">
    </div>-->
  </footer>
</template>
<script>
export default {
  name: "footer-component"
};
</script>
<style scoped lang="scss">
@import "../assets/css/mixins";

footer {
  background-color: #0058A2;
}

.c-footer__wrapper {
  text-align: center;
  padding: 2rem 0;
  @include lg {
    display: flex;
    justify-content: space-between;
    text-align: left;
  }
}

.c-footer__menu {
  @include lg {
    & > div {
      height: 100%;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: center;
    }
    display: flex;
    align-items: center;
    flex-direction: column;
    align-items: flex-start;
  }
}

.c-client-logo {
  width : 80px;
  @include lg {
    align-self: center;
  }
}

.c-footer__copy {
  color: white;
  font-size: 12px;
  @include lg {
    br {
      display: none;
    }
  }
}
.nav {
  display: block;
  margin: 1rem 0;
  @include lg {
    display: flex;
    margin-top: 0;
  }
}
.nav-link {
  letter-spacing: 0.5px;
  color: #fff;
  &:hover {
    text-decoration: underline;
  }
  @include lg {
    &:first-child {
      padding-left: 0;
    }
    font-size: 16px;
  }
}

.c-footer__partners {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
  a {
    margin-bottom: 2rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  span {
    font-size: 12px;
    line-height: 1.17;
    letter-spacing: 0.5px;
    font-weight: 500;
    display: block;
    margin-bottom: 0.5rem;
    color: #fff;
  }
  @include lg {
    display: flex;
    a:first-of-type {
      margin-right: 2rem;
    }
  }
  @include xl {
    a:first-of-type {
      margin-right: 4rem;
    }
  }
}
</style>